import csrfToken from "../../common/helpers/csrf-token";
import * as EventListener from "../../common/helpers/event-listener";

const reviewPagination = () => {
    EventListener.click("product-review-pagination-button", (button) => {
        const page = button.getAttribute("data-page");
        const offerId = button.getAttribute("data-id");

        oc.ajax("Settings::onAjax", {
            data: {
                _token: csrfToken,
                page,
                offer_id: offerId,
            },
            loading: "#loader-line",
            update: {
                "catalog/product-page/review-list.htm":
                    ".product-reviews-wrapper",
            },
            complete: () => {
                document.getElementById("reviewForm").scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            },
        });
    });
};

const addReview = () => {
    EventListener.submit(
        "reviewForm",
        "reviewFormError",
        "reviewFormMessage",
        (formData, button, formError, formMessage, form) => {
            oc.ajax("ProductPage::onAddReview", {
                data: {
                    _token: csrfToken,
                    email: formData.get("email"),
                    name: formData.get("name"),
                    comment: formData.get("comment"),
                    order_id: formData.get("order_id"),
                    offer_id: formData.get("offer_id"),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }

                    if (result.status && result.message) {
                        form.remove();
                        formMessage.textContent = result.message;
                    }
                },
            });
        },
    );
};

reviewPagination();
addReview();
